export class ServiceResult {
    constructor(public successful: boolean, public response: string) {
    }    
}